const radioMarkShapeClassName =
  'h-[18px] w-[18px] rounded-full border border-[#cadcf8] after:absolute after:left-1/2 after:top-1/2 after:h-2 after:w-2 after:-translate-x-1/2 after:-translate-y-1/2 after:rounded-full after:bg-[var(--color-surface)] after:content-[""]';

const radioMarkStandaloneClassName = 'absolute left-0 top-0';

const radioMarkUncheckedEnabledClassName =
  'bg-[var(--color-surface)] after:hidden group-hover:bg-[var(--color-accent)]';

const radioMarkCheckedEnabledClassName =
  'bg-[var(--color-text-muted)] after:block group-hover:bg-[var(--color-text-muted)]';

const radioMarkUncheckedDisabledClassName = 'bg-[var(--color-border)] after:hidden';

const radioMarkCheckedDisabledClassName =
  'bg-[var(--color-form-field-disabled-icon,var(--color-text-muted))] after:block after:bg-[var(--color-form-field-disabled-bg,var(--color-surface))]';

type TParams = {
  checked: boolean;
  disabled: boolean;
  hasLabel: boolean;
};

export const getRadioMarkClassName = ({ checked, disabled, hasLabel }: TParams) => {
  const stateClassName = disabled
    ? checked
      ? radioMarkCheckedDisabledClassName
      : radioMarkUncheckedDisabledClassName
    : checked
      ? radioMarkCheckedEnabledClassName
      : radioMarkUncheckedEnabledClassName;

  return [radioMarkShapeClassName, hasLabel ? 'relative' : radioMarkStandaloneClassName, stateClassName]
    .filter(Boolean)
    .join(' ');
};
